"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPreferredQuality = void 0;
var OrderPreferredQuality;
(function (OrderPreferredQuality) {
    OrderPreferredQuality["Premium"] = "Premium";
    OrderPreferredQuality["Standard"] = "Standard";
    OrderPreferredQuality["Basic"] = "Basic";
})(OrderPreferredQuality || (exports.OrderPreferredQuality = OrderPreferredQuality = {}));
//# sourceMappingURL=order-preferred-quality.enum.js.map